import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=2292d466&scoped=true&"
var script = {}
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=2292d466&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292d466",
  null
  
)

export default component.exports